import Vue from 'vue'
import News from '../components/News'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#news',
  components: { News },
  template: '<News/>'
})



// WEBPACK FOOTER //
// ./src/pages/news.js